import { useEffect, useState } from 'react';
import { ExportButton, TopToolbar } from 'react-admin';
import GroupedSelectColumnsButton from '../GroupedSelectColumnsButton/GroupedSelectColumnsButton';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { ListActionsProps } from '../../../utils/DataTypes';

const ListActions: React.FC<ListActionsProps> = ({ handleSaveAll, handleCancelAll, activeEditRowIds }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), []);

  return (
    <TopToolbar sx={{ position: 'relative', right: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <GroupedSelectColumnsButton />
      <ExportButton maxResults={5000} />
      {activeEditRowIds.length > 1 && (
        <>
          <button
            onClick={handleSaveAll}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              color: '#00909A',
              fontSize: '12px',
            }}
          >
            <SaveIcon style={{ color: '#00909A' }} /> Save All
          </button>
          <button
            onClick={handleCancelAll}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              color: '#00909A',
              fontSize: '12px',
            }}
          >
            <CancelIcon style={{ color: '#00909A' }} /> Cancel All
          </button>
        </>
      )}
    </TopToolbar>
  );
};

export default ListActions;
